import { OrgPermission } from '@equaliq/api-model-v2';

export { OrgPermission };

export const availablePermissions = [
  { key: OrgPermission.manage_members, label: 'Manage Members', description: 'Add, remove, and modify team members' },
  { key: OrgPermission.manage_billing, label: 'Manage Billing', description: 'Access billing information and payment methods' },
  { key: OrgPermission.manage_settings, label: 'Manage Settings', description: 'Modify organization settings and preferences' },
  { key: OrgPermission.view_all_deals, label: 'View All Deals', description: 'Access to view all organization deals' },
  { key: OrgPermission.view_all_files, label: 'View All Files', description: 'Access to view all organization files' },
  { key: OrgPermission.invite_users, label: 'Invite Users', description: 'Send invitations to new team members' },
  { key: OrgPermission.manage_roles, label: 'Manage Roles', description: 'Create and modify custom roles' },
  { key: OrgPermission.view_analytics, label: 'View Analytics', description: 'Access organization analytics and reports' },
  { key: OrgPermission.view_audit_logs, label: 'View Audit Logs', description: 'Access organization audit logs' }
];
